import { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import * as S from './style'
import { ERROR_MESSAGES } from '../../helpers/errorMessages'
import ReactTooltip from 'react-tooltip'
import { GlobalContext } from '../../contexts/Global'
import { colors } from '../../contexts/Theme/tokens'

const Input = ({
  id,
  label,
  description,
  errorMessage,
  helpMessage,
  smallLabel,
  required,
  forgotDetails,
  children,
  ...rest
}) => {
  const {
    state: { isAlternativeActive },
  } = useContext(GlobalContext)
  const { primary, grey, white } = colors

  const [error, setError] = useState(errorMessage)

  const onBlurHandler = (e) => {
    if (required && (!e.target.value || !e.target.value.trim().length)) {
      setError(ERROR_MESSAGES.required)
    } else {
      setError(undefined)
    }
  }

  useEffect(() => {
    if (errorMessage === error) return
    setError(errorMessage)
  }, [errorMessage])

  return (
    <S.InputWrapper>
      <S.InputLabel htmlFor={id} smallLabel={smallLabel}>
        {required && <span>*</span>}
        {label}
      </S.InputLabel>
      {helpMessage && (
        <S.InputLabelInfo>
          <a
            href="javascript:void(0)"
            aria-label="Informazioni"
            data-tip={helpMessage}
            data-for={`${id}-tooltip-top`}
          >
            i
          </a>
          <ReactTooltip
            id={`${id}-tooltip-top`}
            place="top"
            type="info"
            effect="float"
            backgroundColor={isAlternativeActive ? grey : primary.default}
          />
        </S.InputLabelInfo>
      )}
      <S.InputContainer forgotDetails={forgotDetails}>
        <S.InputField
          id={id}
          type="text"
          aria-invalid={error ? true : false}
          aria-describedby={id + '-field-message'}
          isError={!!error}
          forgotDetails={forgotDetails}
          onBlur={onBlurHandler}
          {...rest}
        />
      </S.InputContainer>
      <S.DescriptionContainer
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {error && (
        <S.ErrorMessage
          id={id + '-field-message'}
          role="alert"
          dangerouslySetInnerHTML={{ __html: error }}
        />
      )}
      {children}
    </S.InputWrapper>
  )
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  helpMessage: PropTypes.string,
  type: PropTypes.string,
  smallLabel: PropTypes.bool,
  required: PropTypes.bool,
  forgotDetails: PropTypes.bool,
}

export default Input
